import { useState } from "react";
import { Shield, X } from "lucide-react";
import { cn } from "@/lib/utils";

interface CreditNudgeProps {
  credits: number;
  onViewPlans: () => void;
}

const CreditNudge = ({ credits, onViewPlans }: CreditNudgeProps) => {
  const [dismissed, setDismissed] = useState(false);

  if (dismissed || credits > 3 || credits <= 0) return null;

  const isLast = credits === 1;

  return (
    <div className={cn(
      "border-t",
      isLast
        ? "border-amber-500/30 bg-amber-500/5"
        : "border-cyan/20 bg-cyan/5"
    )}>
      <div className="max-w-6xl mx-auto px-4 py-2.5 flex items-center justify-between gap-3">
        <div className="flex items-center gap-2 min-w-0">
          <Shield className={cn("w-3.5 h-3.5 shrink-0", isLast ? "text-amber-400" : "text-cyan")} />
          <div className="min-w-0">
            <span className={cn("text-xs font-semibold", isLast ? "text-amber-400" : "text-cyan")}>
              {isLast
                ? "Final credit remaining."
                : `Low on credits. ${credits} forensic actions left.`}
            </span>
            <span className="text-xs text-muted-foreground ml-2 hidden sm:inline">
              {isLast
                ? "Purchase a bundle so you can keep decoding messages without interruption."
                : "Credits never expire. Buy more anytime."}
            </span>
          </div>
        </div>
        <div className="flex items-center gap-2 shrink-0">
          <button
            onClick={onViewPlans}
            className={cn(
              "text-xs font-bold px-3 py-1 rounded-md transition-colors",
              isLast
                ? "text-amber-400 hover:bg-amber-400/10"
                : "text-cyan hover:bg-cyan/10"
            )}
          >
            {isLast ? "Buy Credits" : "Buy Credits"}
          </button>
          {!isLast && (
            <button
              onClick={() => setDismissed(true)}
              className="text-muted-foreground hover:text-foreground p-1"
              aria-label="Dismiss"
            >
              <X className="w-3.5 h-3.5" />
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default CreditNudge;
